module.exports = __webpack_public_path__ + "img/UnavailableCouponMark.c4fd2ee0.png";